import { DashboardGrid } from '@practium/ui';
import { useDashboard } from '../hooks/useDashboard';
import type { DashboardProps } from '../types/dashboard.types';

export const Dashboard = ({ config }: DashboardProps) => {
	const { userSummary, stats, promotion, slots, renderSlot } = useDashboard(config);

	return (
		<DashboardGrid
			userSummary={userSummary}
			stats={stats}
			promotion={promotion}
			slots={slots}
			renderSlot={renderSlot}
		/>
	);
};
